<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-first-aid-kit"></i> 就诊列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <div class="search-row">
          <div class="search-item">
            <span class="search-label">就诊人/卡号</span>
            <el-input 
              v-model="searchForm.name" 
              placeholder="请输入就诊人或卡号"
              prefix-icon="el-icon-search"
              clearable
              size="small"
              class="search-input"
            ></el-input>
          </div>
          <div class="search-actions">
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search" size="small">搜索</el-button>
            <el-button @click="resetSearch" icon="el-icon-refresh-right" size="small">重置</el-button>
            <el-button type="success" @click="addData" icon="el-icon-plus" size="small">新增就诊</el-button>
          </div>
        </div>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total"><i class="el-icon-first-aid-kit"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">就诊总数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon amount"><i class="el-icon-money"></i></div>
          <div class="stat-info">
            <div class="stat-value">¥{{ totalAmount }}</div>
            <div class="stat-label">总金额</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon patients"><i class="el-icon-user"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ patientCount }}</div>
            <div class="stat-label">就诊人数</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
          :row-class-name="tableRowClassName"
        >
          <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
          
          <el-table-column label="患者信息" min-width="180">
            <template slot-scope="scope">
              <div class="patient-info">
                <div class="patient-name">
                  <i class="el-icon-user-solid"></i>
                  <span>{{ scope.row.member ? scope.row.member.name : '-' }}</span>
                  <span class="gender" :class="(scope.row.member && scope.row.member.sex == 15) ? 'female' : 'male'">
                    {{ (scope.row.member && scope.row.member.sex == 15) ? '女' : '男' }}
                  </span>
                  <span class="age" v-if="scope.row.member && scope.row.member.birthday">
                    {{ getAge(scope.row.member.birthday) }}岁
                  </span>
                </div>
                <div class="card-num">
                  <i class="el-icon-document"></i>
                  <span>卡号：{{ scope.row.member ? scope.row.member.card_num : '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="就诊信息" min-width="280">
            <template slot-scope="scope">
              <div class="visit-info">
                <div class="diagnosis">
                  <i class="el-icon-first-aid-kit"></i>
                  <span class="label">诊断：</span>
                  <span class="value">{{ scope.row.diagnosis || '-' }}</span>
                </div>
                <div class="remark">
                  <i class="el-icon-document"></i>
                  <span class="label">病例：</span>
                  <span class="value">{{ scope.row.remark || '-' }}</span>
                </div>
                <div class="amount">
                  <i class="el-icon-money"></i>
                  <span class="label">金额：</span>
                  <span class="value amount">¥{{ scope.row.order_amount || 0 }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="就诊日期" width="170" align="center">
            <template slot-scope="scope">
              <span class="time-text">{{ scope.row.creat_time | dateFormat }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                class="detail-btn"
                @click="showGoods(scope.row)"
              >
                <i class="el-icon-view"></i> 详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-first-aid-kit"></i>
        <p>暂无就诊数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 详情抽屉 -->
    <el-drawer
      title="就诊详情"
      :visible.sync="drawer"
      :with-header="false"
      size="500px"
      class="custom-drawer"
    >
      <div class="drawer-header">
        <h3>就诊详情</h3>
        <i class="el-icon-close" @click="drawer = false"></i>
      </div>
      <div class="drawer-content">
        <div class="drawer-info-row">
          <span class="label">产品明细</span>
        </div>
        <el-table
          :data="goods_list"
          stripe
          border
          size="medium"
          :header-cell-style="headerCellStyle"
        >
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column label="产品名称" prop="product_name" min-width="180">
            <template slot-scope="scope">
              <div class="product-name">
                <i class="el-icon-goods"></i>
                <span>{{ scope.row.product_name || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="num" width="100" align="center">
            <template slot-scope="scope">
              <span class="quantity">{{ scope.row.num || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" prop="unit" width="80" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.unit || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="goods_list.length === 0" class="empty-detail">
          <i class="el-icon-document"></i>
          <p>暂无产品明细</p>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "visitList",
  data() {
    return {
      loading: false,
      
      // 搜索表单
      searchForm: {
        name: ""
      },
      
      // 统计数据
      totalAmount: 0,
      patientCount: 0,
      
      // 表格数据
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      // 详情抽屉
      drawer: false,
      goods_list: [],
      
      showType: ''
    }
  },
  created() {
    this.DataList()
  },
  filters: {
    dateFormat(time) {
      if (!time) return ""
      return moment(time * 1000).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  methods: {
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    rowStyle() { return { cursor: 'pointer' } },
    
    tableRowClassName({ row }) {
      if (row.order_amount && row.order_amount > 500) {
        return 'warning-row'
      }
      return ''
    },
    
    calculateStats() {
      if (!this.tableLoadData.length) {
        this.totalAmount = 0
        this.patientCount = 0
        return
      }
      this.totalAmount = this.tableLoadData.reduce((sum, item) => sum + (parseFloat(item.order_amount) || 0), 0).toFixed(2)
      const uniquePatients = new Set(this.tableLoadData.map(item => item.member?.id))
      this.patientCount = uniquePatients.size
    },
    
    getAge(birthday) {
      if (!birthday) return '-'
      const birthDate = new Date(birthday * 1000)
      const now = new Date()
      let age = now.getFullYear() - birthDate.getFullYear()
      const monthDiff = now.getMonth() - birthDate.getMonth()
      if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
        age--
      }
      return age
    },
    
    resetSearch() {
      this.searchForm = { name: "" }
      this.pageNum = 1
      this.DataList()
      this.$message.success('已重置搜索条件')
    },
    
    indexMethod(index) { return (this.pageNum - 1) * this.pageSize + index + 1 },
    
    DataList() {
      this.loading = true
      const param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.searchForm.name) param.keyword = this.searchForm.name
      
      this.$axios.findHisOrderListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    addData() {
      this.$router.push('/hisOrderForm')
    },
    
    showGoods(row) {
      this.goods_list = row.goods || []
      this.drawer = true
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 搜索栏
.search-bar {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .search-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
  }
  
  .search-item {
    display: flex;
    align-items: center;
    gap: 8px;
    .search-label { font-size: 13px; color: #606266; white-space: nowrap; min-width: 100px; text-align: right; }
    .search-input { width: 240px; }
  }
  
  .search-actions {
    display: flex;
    gap: 10px;
    margin-left: auto;
    .el-button { border-radius: 20px; padding: 8px 18px; }
    .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; } }
    .el-button--success { background: #00b578; border-color: #00b578; &:hover { background: #1acd8c; } }
  }
}

// 统计卡片
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 140px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 16px 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon {
      width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff;
      &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.amount { background: linear-gradient(135deg, #e6a23c, #ebb563); }
      &.patients { background: linear-gradient(135deg, #00b578, #1acd8c); }
    }
    .stat-info {
      .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; }
      .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; }
    }
  }
}

// 表格样式
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }

.patient-info {
  .patient-name { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; i { font-size: 14px; color: #1677ff; } span { font-size: 14px; font-weight: 500; } .gender { font-size: 12px; padding: 2px 8px; border-radius: 20px; &.male { background: #e6f4ff; color: #1677ff; } &.female { background: #f0fdf4; color: #00b578; } } .age { font-size: 12px; color: #8c8f98; } }
  .card-num { display: flex; align-items: center; gap: 6px; margin-top: 6px; i { font-size: 12px; color: #909399; } span { font-size: 12px; color: #606266; font-family: monospace; } }
}

.visit-info {
  .diagnosis, .remark, .amount { display: flex; align-items: flex-start; gap: 6px; margin-bottom: 8px; i { font-size: 14px; margin-top: 2px; } .label { font-size: 13px; color: #8c8f98; min-width: 48px; } .value { font-size: 13px; color: #1f2d3d; flex: 1; } }
  .diagnosis i { color: #e6a23c; }
  .remark i { color: #909399; }
  .amount i { color: #ff4d4f; }
  .amount .value.amount { color: #ff4d4f; font-weight: 600; }
}

.time-text { font-size: 12px; color: #8c8f98; }
.detail-btn { color: #1677ff; i { margin-right: 4px; } &:hover { color: #4096ff; } }

.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } .el-button { margin-top: 20px; border-radius: 20px; } }
.pagination-wrapper { display: flex; justify-content: flex-end; padding-top: 16px; border-top: 1px solid #f0f0f0; .el-pagination .el-pager li.active { background: #1677ff; color: #fff; } }

// 抽屉样式
.custom-drawer {
  ::v-deep .el-drawer__body { padding: 0; }
}

.drawer-header {
  display: flex; justify-content: space-between; align-items: center; padding: 20px 24px; background: linear-gradient(135deg, #1677ff, #4096ff); color: #fff;
  h3 { margin: 0; font-size: 18px; font-weight: 500; }
  i { font-size: 20px; cursor: pointer; &:hover { opacity: 0.8; } }
}

.drawer-content { padding: 20px 24px; }
.drawer-info-row { margin-bottom: 16px; .label { font-size: 14px; font-weight: 600; color: #1f2d3d; } }
.product-name { display: flex; align-items: center; gap: 8px; i { color: #e6a23c; } }
.quantity { font-weight: 600; color: #e6a23c; }
.empty-detail { text-align: center; padding: 40px 20px; color: #c0c4cc; i { font-size: 48px; } p { margin-top: 16px; } }

// 行样式
::v-deep .el-table .warning-row { background: #fdf6ec; }
</style>